import { Component, OnInit, EventEmitter, Input, Output, OnChanges, SimpleChanges } from '@angular/core';
import { APIURL } from 'app/Shared/Constant/API_Urls';
import { ConstantService } from 'app/Shared/Services/constant-service';
import { DataService } from 'app/Shared/Services/data.service';
import { SharedHttpClientService } from 'app/Shared/Services/shared-http-client.service';
import { UrlsService } from 'app/Shared/Services/urls.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { CaisServiceService } from '../../cais-service.service';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, FormControl, Validators } from '@angular/forms';
import { ToastModule } from 'primeng/toast';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { NgClass} from '@angular/common';
import { InputMaskModule } from 'primeng/inputmask';

@Component({
    selector: 'app-tid-generator',
    templateUrl: './tid-generator.component.html',
    imports: [ButtonModule, DialogModule, ConfirmDialogModule, MatTooltipModule, ReactiveFormsModule, FormsModule, ToastModule, ToggleSwitchModule, InputMaskModule, NgClass],
    providers: [MessageService, ConfirmationService,
        ConstantService],
    styleUrls: ['./tid-generator.component.scss']
})
export class TidGeneratorComponent implements OnInit, OnChanges {
  @Input('GeneratorType') generatorType: any = "DefaultTIDGenerator";
  @Input('UserType') userType: any;
  @Input('TIDType') userTIDType: any;
  @Input('foreignTIDType') userForeignTIDType: any;
  @Output() receiveTIDValue: EventEmitter<boolean> = new EventEmitter<boolean>();

  tidGenerationForm!: FormGroup;
  userPreEncoded: string = '';
  userPostEncoded: string = '';
  maxLength!: number;
  needOfMaskField: boolean = false;
  tidGeneratorMask!: string;
  tidGeneratorFieldLabel: string = 'Tax/Govt Id (SSN/EIN/LEI/Govt Id)';

  constructor(
    private fb: FormBuilder,
    private urlService: UrlsService,
    private messageService: MessageService,
    public confirmationService: ConfirmationService,
    public constantService: ConstantService,
    public dataService: DataService,
    private sharedHttpClientService: SharedHttpClientService,
    public caisServiceService: CaisServiceService
  )  {
    /* TID Generation Form Builder Instance Creation */
      this.tidGenerationForm = new FormGroup({
        tid_generator_switch: new FormControl({value: false, disabled: false}, {validators: [Validators.required]}),
        tid_generator_input: new FormControl({value: '', disabled: true}, {validators: [Validators.required, Validators.pattern(/^[a-zA-Z0-9]{1,100}$/)], updateOn: 'change'})
      });
    /* End of TID Generation Form Builder Instance Creation */
  }

  ngOnInit() {
    this.userPreEncoded= '';
    this.userPostEncoded= '';

    /* Receive Update for the change of TID Generator Switch Value */
      this.tidGenerationForm.get('tid_generator_switch')?.valueChanges.subscribe((isChecked) => {
        const inputControl = this.tidGenerationForm.get('tid_generator_input');
        (isChecked ? inputControl?.enable() : inputControl?.disable());
      });
    /* End of Receive Update for the change of TID Generator Switch Value */
  }

  ngOnChanges(changes: SimpleChanges): void {
    /* Update TID Generator Form Field-Label, Mask, PlaceHolder, Field-Type & Validation */
      if(this.userTIDType==="SSN/ITIN") {
        this.tidGeneratorFieldLabel = this.userTIDType;
        this.needOfMaskField = true;
        this.tidGeneratorMask = "999-99-9999";
        this.tidGenerationForm.get('tid_generator_input')?.setValidators([Validators.required, Validators.pattern(/^\S+$/), Validators.pattern(/^\d{3}-\d{2}-\d{4}$/)]);
      } else if (this.userTIDType==="EIN") {
        this.tidGeneratorFieldLabel = this.userTIDType;
        this.needOfMaskField = true;
        this.tidGeneratorMask = "99-9999999";
        this.tidGenerationForm.get('tid_generator_input')?.setValidators([Validators.required, Validators.pattern(/^\S+$/), Validators.pattern(/^\d{2}-\d{7}$/)]);
      } else if (this.userTIDType==="FOREIGN" && this.userForeignTIDType==="LEI") {
        this.tidGeneratorFieldLabel = this.userForeignTIDType;
        this.needOfMaskField = false;
        this.maxLength = 20;
        this.tidGeneratorMask = "Please Enter 20 Characters";
        this.tidGenerationForm.get('tid_generator_input')?.setValidators([Validators.required, Validators.pattern(/^\S+$/), Validators.pattern(/^[a-zA-Z0-9]{1,20}$/)]);
      } else {
        this.tidGeneratorFieldLabel = "Tax/Govt Id (SSN/EIN/LEI/Govt Id)";
        this.needOfMaskField = false;
        this.maxLength = 100;
        this.tidGeneratorMask = "Please Enter Value";
        this.tidGenerationForm.get('tid_generator_switch')?.setValue(false); // Reset TID Generator Switch Value
        this.tidGenerationForm.get('tid_generator_input')?.setValue(""); // Reset TID Generator Input Value
        this.tidGenerationForm.get('tid_generator_input')?.setValidators([Validators.required, Validators.pattern(/^\S+$/), Validators.pattern(/^[a-zA-Z0-9]{1,100}$/)]);
      }
    /* End of Update TID Generator Form Field-Label, Mask, PlaceHolder, Field-Type & Validation */
  }
  
  /* Allow to enable TID Generator Button */
  enableTIDGenerateBtn(tidGeneratorInput: any){
    return !(!tidGeneratorInput?.disabled && !tidGeneratorInput?.invalid);
  }

  generateTID() {
    if(this.userPreEncoded) {
      this.sharedHttpClientService.post(
        this.urlService.setAPIURl(
          APIURL.CAIS_Generate_TID_Hash
        ), {
          tidValue: this.userPreEncoded
        })
        .subscribe({
          next: (res:any) => {
          let resultSet: any = res;
          this.userPostEncoded = (resultSet.tidValue ? resultSet.tidValue : "");
        }});
    } else {
      this.messageService.add({ severity: this.constantService.MESSAGE_SEVERITY_WARN, summary: this.constantService.MESSAGE_SUMMARY_INFO, detail: 'Please Enter Id Value' });
    }
  }

  /* Generate and Save TID Value for NaturalPaerson | LegalEntity */
  generateAndPrepareTID(userType: any, TIDGeneratingInput: any) {
    if(TIDGeneratingInput) {
      this.sharedHttpClientService.post(
        this.urlService.setAPIURl(
          APIURL.CAIS_Generate_TID_Hash
        ), {
          tidValue: TIDGeneratingInput
        })
        .subscribe({
          next: (res:any) => {
          let resultSet: any = res;
          this.caisServiceService.emptyForeginTIDValue(userType);
          this.caisServiceService.updateForeginTIDValue(userType, (resultSet.tidValue ? resultSet.tidValue : ""));
          this.receiveTIDValue.emit();
        }});
    } else {
      this.messageService.add({ severity: this.constantService.MESSAGE_SEVERITY_WARN, summary: this.constantService.MESSAGE_SUMMARY_INFO, detail: 'Please Enter Value for TID' });
    }
  }

  copytoClipboard(elementInput:any) {
    elementInput.select();
    document.execCommand('copy');
    elementInput.setSelectionRange(0, 0);
  }

  saveTID(type: 'LegalEntity' | 'NaturalPerson'){
    this.caisServiceService.updateForeginTIDValue(type,this.userPostEncoded);
    this.caisServiceService.isDisplayTIDGenerator = false;   
  }

}
